import Config from './config.json';

export const PER_PAGE = 20;

export const ROW_PER_PAGE_OPTIONS = [20, 50, 100];

export const REACT_APP_GOOGLE_CLIENT_ID =
  Config.REACT_APP_GOOGLE_CLIENT_ID ||
  '220765558606-3c39acq8l0i1k3lber1mkg0umd5gnbhd.apps.googleusercontent.com';
